<template>
  <Public header="company-list" :companyCount="companies.length">
    <v-app id="app" class="mt-10">
      <v-main>
        <v-container>
          <select-company v-if="companies.length > 0 && checkEmptyCompany()"></select-company>
          <menu-register-company v-else-if="companies.length === 0"></menu-register-company>
          <div v-else style="height: 1000px"></div>
        </v-container>
        <footer-web></footer-web>
      </v-main>
    </v-app>
  </Public>
</template>

<script>
import {mapState} from 'vuex'
import FooterWeb from '@/components/public/footer'
import SelectCompany from '../../components/company/select-company'
import MenuRegisterCompany from '../../components/company/menu-register-company'
import Public from '@/components/public/public-main-template'

const _ = require('lodash');

export default {
  name: 'companies',
  components: {
    FooterWeb,
    SelectCompany,
    MenuRegisterCompany,
    Public
  },
  computed: mapState({
    companies: state => state.companies.list,
  }),
  created() {
    this.$store.dispatch('companies/getList')
  },
  methods: {
    checkEmptyCompany: function () {
      return !_.isEmpty(this.companies[0]['company'])
    }
  }
}
</script>

<style lang="scss">
* {
  font-family: "Noto Sans Thai", "Noto Sans", sans-serif;
}

.register-logo {
  width: 100px;
  display: block;
  margin: 20px auto;
}

.main {
  min-height: 500px;
}
</style>
